export default "__VITE_ASSET__270b8e0a__"